if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('.header__nav-row-menu header-menu > details.mega-menu').forEach((details) => {
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => details.removeAttribute('open'), 150);
    });
  });
}
